import React, { Fragment, useState, useEffect } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';

import img1 from "../../images/public-awareness/1.webp";
import img2 from "../../images/public-awareness/2.webp";
import img3 from "../../images/public-awareness/3.webp";
import img4 from "../../images/public-awareness/4.webp";
import img5 from "../../images/public-awareness/5.webp";
import img6 from "../../images/public-awareness/6.webp";
import img7 from "../../images/public-awareness/7.webp";
import img8 from "../../images/public-awareness/8.webp";

import metadataJSON from "../../data/metadata.json";
import schemadataJSON from "../../data/schemadata.json";
import { Helmet } from 'react-helmet';

const PublicAwarenessProgram = ({ path }) => {

    // Setting metadata and schemadata 
    const [metadata, setMetadata] = useState({title: "JJFIndia | Our Initiative"});
    const [schemadata, setSchemadata] = useState({});
    
    // Getting the schemadata and setting the schema data. 
    useEffect(() => {
        let tempMetadata = metadataJSON[path];
        let tempSchemadata = schemadataJSON[path];

        if(tempMetadata){
        setMetadata(tempMetadata);
        }else {
        tempMetadata = {
            title: "JJFIndia | Gallery",
            description: "JJFIndia Gallery page",
            keywords: "",
            robots: "index, follow",
            canonical: "https://jjfindia.com/gallery/tree-plantation",
            openGraph: {
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page",
                url: "https://jjfindia.com/gallery/tree-plantation"
            },
            twitter: {
                card: "summary_large_image",
                title: "JJFIndia | Gallery",
                description: "JJFIndia Gallery page"
            }
        }

        setMetadata(tempMetadata);
        }

        // setting schema data 
        if(tempSchemadata) {
            setSchemadata(tempSchemadata);
        }

    }, [path]);

    return (
        <>
            <Helmet>
                {/* Basic Meta Tags */}
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <meta name="robots" content={metadata.robots} />
        
                {/* Canonical URL */}
                <link rel="canonical" href={metadata.canonical} />
        
                {/* Open Graph */}
                <meta property="og:title" content={metadata.openGraph?.title} />
                <meta property="og:description" content={metadata.openGraph?.description} />
                <meta property="og:url" content={metadata.canonical} />
        
                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content={metadata.twitter?.title} />
                <meta name="twitter:description" content={metadata.twitter?.description} />
                
                {/* Setting up schema data */}
                <script  type="application/ld+json" >{JSON.stringify(schemadata, null, 2)}</script>
            </Helmet>

            <Fragment>
                <Header hclass={'header--styleFour'} />
                <main className="page_content">
                    <PageTitle pageTitle={'Public Awareness Program'} pagesub={'Gallery'} />

                
                    <section className="blog pt-60">
                        <div className="container">
                            <div className="row align-items-end">
                                <div className="col-12">
                                    <div className="sectionTitle mb-40" id='feature'>
                                        <span className="sectionTitle__small justify-content-center">
                                            <i className="fa-solid fa-heart btn__icon"></i>Public Awareness Program
                                        </span>
                                        <h1 className="sectionTitle__big text-center">Public Awareness Program</h1>
                                        <p className='text-center' style={{ fontSize: '24px' }}>Glimpses of our outreach initiatives, fostering dialogue and inspiring participation.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-40">
                                        <figure className="blogBlock__figure">
                                            {/* <Link to="#" */}
                                            {/* onClick={(e) => e.preventDefault()} className="blogBlock__figure__link"> */}
                                            <img src={img1} alt="Volunteers distributing awareness pamphlets outdoors" className="blogBlock__figure__image" />
                                            {/* </Link> */}
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img2} alt="Group of volunteers posing during a public awareness event" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img3} alt="Volunteers speaking to students during an outdoor awareness session" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img4} width={400} loading='lazy' alt="Volunteers holding awareness posters during the program" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img5} width={400} loading='lazy' alt="Volunteers standing with awareness materials after the event." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img6} width={400} loading='lazy' alt="Students and volunteers holding posters during the awareness campaign" className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img7} width={400} loading='lazy' alt="Volunteers distributing educational material during the program." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="blogBlock blogBlock--style3 mb-60">
                                        <figure className="blogBlock__figure">
                                            <img src={img8} width={400} loading='lazy' alt="Two volunteers holding awareness leaflets at the event." className="blogBlock__figure__image" />
                                        </figure>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>


                </main>
                <Footer />
                <Scrollbar />
            </Fragment>
        </>
    )
};

export default PublicAwarenessProgram;
